import React, { useState } from "react";

import AssignLabels from "../../../_utils/AccountCreationComponents/AssignLabels";
import RolesTagsContainer from "./RolesTagsContainer";
import ICONS from "../../../../assets/Icons";
import CommonAssignTagPopup from "../../../_utils/CommonPopups/CommonAssignTagPoppup";

const AssignUserRoletags = ({
  roleAssigned,
  setRoleAssigned,
  tagsAssigned,
  setTagsAssigned,
  AllTags,
  setAllTags,
  newTags,
  setNewTags,
  AllRoles,
  setAllRoles,
  newRoles,
  setNewRoles,
}) => {
  const handleCloseModalTags = () => {
    setTagsAssigned(false);
    setAllTags((prev) =>
      prev.map((item) => ({
        ...item,
        selected: true,
      })),
    );
    setNewTags((prev) =>
      prev.map((item) => ({
        ...item,
        selected: true,
      })),
    );
  };

  const handleAddTags = async (item) => {
    setNewTags((prevTags) => [
      ...prevTags,
      ...item.map((obj) => ({
        ...obj,
        selected: true,
      })),
    ]);
  };

  const handleRemoveTags = async () => {
    setNewTags((prevNewRoles) => {
      const removedRoles = prevNewRoles
        .filter((role) => role.selected === false)
        .map((role) => ({
          ...role,
          selected: true,
        }));

      setAllTags((prevAllRoles) => [...prevAllRoles, ...removedRoles]);

      return prevNewRoles.filter((role) => role.selected !== false);
    });
  };

  const handleCloseModalRoles = () => {
    setRoleAssigned(false);
    setAllRoles((prev) =>
      prev.map((item) => ({
        ...item,
        selected: true,
      })),
    );

    setNewRoles((prev) =>
      prev.map((item) => ({
        ...item,
        selected: true,
      })),
    );
  };

  const handleAddRoles = async (item) => {
    setNewRoles((prevTags) => [
      ...prevTags,
      ...item.map((obj) => ({
        ...obj,
        selected: true,
      })),
    ]);
  };

  const handleRemoveRoles = async () => {
    setNewRoles((prevNewRoles) => {
      const removedRoles = prevNewRoles
        .filter((role) => role.selected === false)
        .map((role) => ({
          ...role,
          selected: true,
        }));

      setAllRoles((prevAllRoles) => [...prevAllRoles, ...removedRoles]);

      return prevNewRoles.filter((role) => role.selected !== false);
    });
  };

  const [loading, setLoading] = useState(false);

  const [existingTags, setExistingTags] = useState([]);
  const [existingRole, setExistingRole] = useState([]);

  const tagsDes = {
    searchPlaceholderDescription: "Search / Enter new tag",
    title7: "No assigned tags found.",
    title8: "No unassigned tags found.",
    title5: "Tag selected",
    title1: "Assigned tags",
    title2: "Unassigned tags",
    zeroValueDescription: `To assign tags, select from the list of unassigned tags and click "Assign"`,
  };

  const rolesDes = {
    searchPlaceholderDescription: "Search by role name",
    headerDescription: "The user’s role within the entity.",
    title3: `Select roles and click "Unassign" to unlink them from the user.`,
    title4: `Select roles and click "Assign" to link them to the user.`,
    title5: "Total roles selected",
    title7: "No assigned roles found.",
    title8: "No unassigned roles found.",
    title1: "Assigned roles",
    title2: "Unassign roles",
    zeroValueDescription: `To assign roles, select from the list of unassigned roles and click "Assign"`,
  };

  return (
    <div className="flex flex-col Qsmd:flex-row px-padding-md lg:px-padding-base py-padding-md Qsmd:py-padding-base Qsmd:gap-gap-xl gap-gap-md relative">
      {tagsAssigned && (
        <div
          className="fixed top-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-max left-left-base"
          onClick={handleCloseModalTags}
        >
          {
            <CommonAssignTagPopup
              headerTitle="Assign/Unassign tags:"
              closehandleFunction={handleCloseModalTags}
              closedisabledBgColor=""
              closebuttonRef=""
              closeimgColor=""
              loading={loading}
              newTags={newTags}
              handleAddTags={handleAddTags}
              existingTags={existingTags}
              setExistingTags={setExistingTags}
              handleRemoveTags={handleRemoveTags}
              setNewTags={setNewTags}
              ownerExistingTag={[]}
              AllTags={AllTags}
              setAllTags={setAllTags}
              setLoading={setLoading}
              getOwnerDetaildata={[]}
              ownerDetailData={[]}
              dummyUser={true}
              type={"ownerDetails"}
              users={true}
              description={tagsDes}
            />
          }
        </div>
      )}

      {roleAssigned && (
        <div
          className="fixed top-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-max left-left-base"
          onClick={handleCloseModalTags}
        >
          {
            <CommonAssignTagPopup
              headerTitle="Assign/Unassign roles:"
              closehandleFunction={handleCloseModalRoles}
              closedisabledBgColor=""
              closebuttonRef=""
              closeimgColor=""
              loading={loading}
              newTags={newRoles}
              handleAddTags={handleAddRoles}
              existingTags={existingRole}
              setExistingTags={setExistingRole}
              handleRemoveTags={handleRemoveRoles}
              setNewTags={setNewRoles}
              ownerExistingTag={[]}
              AllTags={AllRoles}
              setAllTags={setAllRoles}
              setLoading={setLoading}
              getOwnerDetaildata={[]}
              ownerDetailData={[]}
              dummyUser={true}
              type={"ownerDetails"}
              users={true}
              description={rolesDes}
              typeForSpaces={"privateTxn"}
            />
          }
        </div>
      )}
      <div className="flex flex-col Qsmd:flex-row w-width-full gap-gap-md Qsmd:gap-gap-xl">
        <div className="flex flex-col relative w-width-full Qsmd:w-width-md lg:max-w-[var(--create-box-width)]">
          <RolesTagsContainer
            setLabelpopup={setRoleAssigned}
            labels={newRoles}
            subText1="The user’s role within the entity."
            isOptional={false}
            title={"Roles"}
            buttonName={"Assign Role"}
            buttonImageUrl={ICONS.ROLES_WITHOUT_CIRCLE}
            handleOnClick={() => {
              setRoleAssigned(true);
            }}
          />
        </div>
        <div className="flex flex-col relative w-width-full Qsmd:w-width-md lg:max-w-[var(--create-box-width)]">
          <RolesTagsContainer
            setLabelpopup={setTagsAssigned}
            labels={newTags}
            subText1="These will be used to give access of owner accounts to the users who share even one of the assigned tags. "
            isOptional={true}
            title={"Tags"}
            buttonName={"Assign Tags"}
            buttonImageUrl={ICONS.ASSIGN_TAG_WITHOUT_CIRCLE}
            handleOnClick={() => {
              setTagsAssigned(true);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default AssignUserRoletags;
